import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation
} from "@angular/core";
import { PaginationConfig } from "ngx-bootstrap/pagination";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class PaginationComponent implements OnInit {

  @Input() pagination: any;
  @Output() pageChanged: EventEmitter<any> = new EventEmitter();

  constructor(private config: PaginationConfig,public translate: TranslateService) {
    this.config.main.boundaryLinks = true;
    this.config.main.rotate = false;
    this.config.main.maxSize = 5;
    this.config.main.previousText = "&lsaquo;";
    this.config.main.nextText = "&rsaquo;";
    this.config.main.firstText = "&laquo;";
    this.config.main.lastText = "&raquo;";
  }

  ngOnInit() {}

  showingMessage(pagination?: any) {
    let start = (pagination.page - 1) * pagination.pageSize + 1;
    let end =
      pagination.page * pagination.pageSize < pagination.collectionSize
        ? pagination.page * pagination.pageSize
        : pagination.collectionSize;
    let page = pagination.collectionSize;

    return this.translate.instant('PAGINATION.Pagination', {start : start, end : end, page : page});
  }

  paginationOnChange($event: any) {
    this.pageChanged.emit($event);
  }
}
